export enum RoutePermission {
    contract = 'contract',
    viewUserlist = 'view.userlist',
    courseSynchronization = 'coursesynchronization',
    viewFullSynchronization = 'view.fullsynchronization',
    initiateFullSynchronization = 'initiate.fullsynchronization',
    viewCourseList = 'view.courselist',
    viewFacultyMappings = 'view.facultymappings',
    viewContractInstructors = 'view.contractinstructors',
    login = 'login',
    auxiliarycourse = 'auxiliarycourse',
    viewStaffRoleOverrides = 'view.staffroleoverrides',
    staffRoleOverride = 'staffroleoverride',
    admin = 'admin'
}
